export default __webpack_public_path__ + "static/media/IpserLabLogo.f3b8e453.png";